export default __webpack_public_path__ + "aff8a9cb398fc75e4f21dab1ba1e097e.svg";